// @ts-nocheck
import { svelteHelpers } from "@propublica/pp-frontend";

function throttle(fn, ms) {
    let last = 0;
    return (...args) => {
        const now = Date.now();
        if (now - last >= ms) { last = now; fn(...args); }
    };
}

import * as components from "./svelte-components.js";

import * as d3 from "d3";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.config({ ignoreMobileResize: true });
window.addEventListener('load', () => requestAnimationFrame(() => ScrollTrigger.refresh()));

const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
const isChrome = /CriOS/.test(navigator.userAgent);

if (isIOS && !isChrome) {
  ScrollTrigger.normalizeScroll(true);
}

svelteHelpers.hydrateAllComponentsOnPage(components);

//universal variables
const screenSize = window.matchMedia("(max-width: 59.999em)").matches ? "mobile" : "desktop";

// if (screenSize === "mobile") { ScrollTrigger.normalizeScroll(true); }

const projectionColor = "#8eb4bd";
const projectionLabel = "#5892A4";
document.documentElement.style.setProperty('--chart-projections', projectionColor);
const actualColor = "#7D6162";
const actualLabel = "#7D6162"
const colorTextBody = "rgb(49, 48, 45)"
document.documentElement.style.setProperty('--chart-projections', projectionColor);
document.documentElement.style.setProperty('--chart-projections-label', projectionLabel);
document.documentElement.style.setProperty('--chart-actual', actualColor);
document.documentElement.style.setProperty('--chart-actual-label', actualLabel);
const axisColor = 'var(--p-color-gray-03)';
const axisOpacity = 0.6;
const axisTextOpacity = 0.75;

// --- Image sequence helpers ---

// Generate a URL array for a numbered image sequence
function makeUrls(baseUrl, count, startIndex, pad = 2, ext = "jpg") {
    return Array.from({ length: count }, (_, i) =>
        `${baseUrl}${String(i + startIndex).padStart(pad, "0")}.${ext}`
    );
}

// Load urls into a frames array in staggered batches so early frames get priority.
// staggerMs=0 fires all batches immediately (for small sequences).
function loadInBatches(urls, frames, startIdx = 0, batchSize = 10, staggerMs = 50) {
    const numBatches = Math.ceil((urls.length - startIdx) / batchSize);
    for (let b = 0; b < numBatches; b++) {
        const batchStart = startIdx + b * batchSize;
        const batchEnd = Math.min(batchStart + batchSize, urls.length);
        setTimeout(() => {
            for (let i = batchStart; i < batchEnd; i++) {
                const img = new Image();
                img.src = urls[i];
                frames[i] = img;
            }
        }, b * staggerMs);
    }
}

// Start loading a sequence once its trigger element scrolls within rootMargin of the viewport
function observeForLoad(selector, onLoad, rootMargin = "200% 0px") {
    const el = document.querySelector(selector);
    if (!el) return;
    const observer = new IntersectionObserver(
        ([entry], obs) => {
            if (entry.isIntersecting) {
                onLoad();
                obs.disconnect();
            }
        },
        { rootMargin }
    );
    observer.observe(el);
}

// Return the nearest already-loaded frame at or before index (graceful fallback while loading)
function nearestFrame(frames, index) {
    for (let i = index; i >= 0; i--) {
        if (frames[i]?.src) return frames[i];
    }
    return null;
}

// --- Opener image sequence (84 frames, top of page — eager batched load) ---
const OPENER_TOTAL_FRAMES = 81;
const OPENER_BASE_URL = screenSize === "desktop"
    ? "https://static.propublica.org/projects/graphics/2026-ccs-explainer/20260613-opener/20260613-opener-desktop-"
    : "https://static.propublica.org/projects/graphics/2026-ccs-explainer/20260613-opener/20260613-opener-mobile-";
const openerUrls = makeUrls(OPENER_BASE_URL, OPENER_TOTAL_FRAMES, 1);
const openerFrames = new Array(OPENER_TOTAL_FRAMES).fill(null);
const openerImg = document.querySelector("#opener-sequence");
// Frame 0 is preloaded in <head>; wire it up immediately
const openerFirst = new Image();
openerFirst.src = openerUrls[0];
openerFrames[0] = openerFirst;
openerImg.src = openerUrls[0];
// Load remaining frames in staggered batches so frames 1–10 arrive before 11–20, etc.
loadInBatches(openerUrls, openerFrames, 1, 10, 50);

ScrollTrigger.create({
    id: "opener-sequence-scrubber",
    trigger: "#opener-step-1",
    start: "top 80%",
    endTrigger: "#opener-step-4",
    end: "top center",
    onUpdate: (self) => {
        const frameIndex = Math.min(
            Math.floor(self.progress * OPENER_TOTAL_FRAMES),
            OPENER_TOTAL_FRAMES - 1
        );
        const frame = nearestFrame(openerFrames, frameIndex);
        if (frame) openerImg.src = frame.src;
    },
});





// Fade in opener text (desktop only) //
if (window.matchMedia("(min-width: 60em)").matches) {
    [2, 3, 4].forEach(n => {
        gsap.timeline({
            scrollTrigger: {
                trigger: `#opener-step-${n}`,
                start: "top 80%",
                end: "top center",
                scrub: true,
            }
        })
        .to(`#opener-step-text-${n - 1}`, { opacity: 0, duration: 1 }, 0)
        .to(`#opener-step-text-${n}`, { opacity: 1, duration: 1 }, 0);
    });
} else {
    [1, 2, 3, 4].forEach(n => {
        const el = document.querySelector(`#opener-step-text-${n}`);
        if (el) el.style.opacity = 1;
    });
}


// How it works animation //

gsap.set(["#howitworks-step1", "#howitworks-step2", "#howitworks-step3", "#howitworks-step4"], { opacity: 0 });

["#howitworks-step1", "#howitworks-step2", "#howitworks-step3", "#howitworks-step4"].forEach(id => {
    gsap.to(id, {
        opacity: 1,
        scrollTrigger: {
            trigger: id,
            start: "top center",
            end: "+=200",
            scrub: true,
            //markers: true,
        }
    });
});

const hwImgSuffix = screenSize === "desktop" ? "" : "-mobile";
const hwImgIds = [1, 2, 3].map(n => `#howitworks-${n}${hwImgSuffix}`);
const hwImgTriggers = ["#howitworks-step1", "#howitworks-step2", "#howitworks-step3"];


const isXlDesktop  = window.matchMedia("(min-width: 78em)").matches;
const isMdDesktop  = window.matchMedia("(min-width: 60em) and (max-width: 77.999em)").matches;
const isTablet     = window.matchMedia("(min-width: 36em) and (max-width: 59.999em)").matches;
// xs: < 36em

gsap.set("#howitworks-step5", { opacity: 0 });

if (isXlDesktop) {
    gsap.timeline({
        scrollTrigger: {
            trigger: ".artboard-text-box",
            start: "center center",
            endTrigger: "#howitworks-5",
            end: "bottom 70%",
            pin: true,
            scrub: 1,
            pinSpacing: false,
        }
    })
    .to({}, { duration: 0.5 })
    .to("#howitworks-step5", { opacity: 1, duration: 0.5 })
    .to({}, { duration: 1 })
    .to("#howitworks-cloud-2", { opacity: 0, duration: 1 });
} else if (isMdDesktop) {
    gsap.timeline({
        scrollTrigger: {
            trigger: ".artboard-text-box",
            start: "center center",
            endTrigger: "#howitworks-5",
            end: "bottom 75%",
            pin: true,
            scrub: 1,
            pinSpacing: false,
           // markers:true,
        }
    })
    .to({}, { duration: 0.5 })
    .to("#howitworks-step5", { opacity: 1, duration: 0.5 })
    .to({}, { duration: 1 })
    .to("#howitworks-cloud-2", { opacity: 0, duration: 1 });
} else if (isTablet) {
    // tablet (36em–60em)
    gsap.timeline({
        scrollTrigger: {
            trigger: ".artboard-text-box",
            start: "center center",
             endTrigger: "#howitworks-5-mobile",
            end: "bottom 68%",
            pin: true,
            scrub: 1,
            pinSpacing: false,
           // markers:true,
        }
    })
    .to({}, { duration: 0.5 })
    .to("#howitworks-step5", { opacity: 1, duration: 0.5 })
    .to({}, { duration: 1 })
    .to("#howitworks-cloud-2", { opacity: 0, duration: 1 });
} else {
    // xs (< 36em)
    gsap.timeline({
        scrollTrigger: {
            trigger: ".artboard-text-box",
            start: "center center",
             endTrigger: "#howitworks-5-mobile",
            end: "bottom 63%",
            pin: true,
            scrub: 1,
            pinSpacing: false,
           // markers:true,
        }
    })
    .to({}, { duration: 0.5 })
    .to("#howitworks-step5", { opacity: 1, duration: 0.5 })
    .to({}, { duration: 1 })
    .to("#howitworks-cloud-2", { opacity: 0, duration: 1 });
}


// --- Footprint image sequence (59 frames, lazy-loaded when section nears viewport) ---
const FOOTPRINT_TOTAL_FRAMES = 22;
const FOOTPRINT_BASE_URL = screenSize === "desktop"
    ? "https://static.propublica.org/projects/graphics/2026-ccs-explainer/factories_expansion/20260529-village-factories-desktop-"
    : "https://static.propublica.org/projects/graphics/2026-ccs-explainer/factories_expansion/20260529-village-factories-mobile-";
const footprintUrls = makeUrls(FOOTPRINT_BASE_URL, FOOTPRINT_TOTAL_FRAMES, 1, 2, "webp");
const footprintFrames = new Array(FOOTPRINT_TOTAL_FRAMES).fill(null);
const footprintImg = document.querySelector("#footprint-sequence");
const footprintFirst = new Image();
footprintFirst.src = footprintUrls[0];
footprintFrames[0] = footprintFirst;
footprintImg.src = footprintUrls[0];
observeForLoad("#footprint-step1", () => loadInBatches(footprintUrls, footprintFrames, 1, 10, 30));

const footprintWrapper =  document.querySelector("#footprint-wrapper");
footprintWrapper.style.opacity = 0;


ScrollTrigger.create({
    id: "footprint-sequence-scrubber",
    trigger: "#footprint-step1",
    start: "top center",
    endTrigger: "#footprint-step3",
    end: "top bottom",
    onUpdate: (self) => {
        const frameIndex = Math.min(
            Math.floor(self.progress * FOOTPRINT_TOTAL_FRAMES),
            FOOTPRINT_TOTAL_FRAMES - 1
        );
        const frame = nearestFrame(footprintFrames, frameIndex);
        if (frame) footprintImg.src = frame.src;
    },
});

ScrollTrigger.create({
    trigger: ".footprint-sequence-wrapper",
    start: "top center",
    end: "top 20%",
    //markers:true,
    onUpdate: (self) => {
        footprintWrapper.style.opacity = self.progress;
    },
});


// --- Plants takeover image sequence (11 frames, lazy-loaded when footprint-step3 nears viewport) ---
const PLANTS_TOTAL_FRAMES = 11;
const PLANTS_BASE_URL = screenSize === "desktop"
        ? "https://static.propublica.org/projects/graphics/2026-ccs-explainer/plants_takeover/20260602-grass-desktop-"
        : "https://static.propublica.org/projects/graphics/2026-ccs-explainer/plants_takeover/20260616-plants-mobile-step-";
const plantsUrls = makeUrls(PLANTS_BASE_URL, PLANTS_TOTAL_FRAMES, 1, 2, "webp");
const plantsFrames = new Array(PLANTS_TOTAL_FRAMES).fill(null);
const plantsImg = document.querySelector("#plants-sequence");
plantsImg.removeAttribute("src");
const plantsFirst = new Image();
plantsFirst.src = plantsUrls[0];
plantsFrames[0] = plantsFirst;
observeForLoad("#footprint-step3", () => loadInBatches(plantsUrls, plantsFrames, 1, 5, 30));

ScrollTrigger.create({
    id: "plants-sequence-scrubber",
    trigger: "#footprint-step3",
    start: "top center",
    endTrigger: "#footprint-step4",
    end: "top top",
    onEnter: () => { plantsImg.style.display = "block"; },
    onLeaveBack: () => { plantsImg.style.display = "none"; },
    onUpdate: (self) => {
        const frameIndex = Math.min(
            Math.floor(self.progress * PLANTS_TOTAL_FRAMES),
            PLANTS_TOTAL_FRAMES - 1
        );
        const frame = nearestFrame(plantsFrames, frameIndex);
        if (frame) plantsImg.src = frame.src;
    },
});

// --- Dumpster earth image sequence (3 frames, lazy-loaded) ---
const DUMPSTEREARTH_TOTAL_FRAMES = 23;
const DUMPSTEREARTH_BASE_URL =
    "https://static.propublica.org/projects/graphics/2026-ccs-explainer/globe-steps/20260611-globe-step-desktop-";
const dumpsterearthUrls = makeUrls(DUMPSTEREARTH_BASE_URL, DUMPSTEREARTH_TOTAL_FRAMES, 1, 2, "webp");
const dumpsterearthFrames = new Array(DUMPSTEREARTH_TOTAL_FRAMES).fill(null);
const dumpsterearthImg = document.querySelector("#dumpsterearth-sequence");
const dumpsterearthFirst = new Image();
dumpsterearthFirst.src = dumpsterearthUrls[0];
dumpsterearthFrames[0] = dumpsterearthFirst;
observeForLoad("#dumpsterearth-step1", () => loadInBatches(dumpsterearthUrls, dumpsterearthFrames, 1, 10, 0));

ScrollTrigger.create({
    id: "dumpsterearth-sequence-scrubber",
    trigger: "#dumpsterearth-step1",
    start: "top 90%",
    endTrigger: "#dumpsterearth-step2",
    end: "top center",
    onEnter: () => {
        const frame = dumpsterearthFrames[0];
        if (frame) dumpsterearthImg.src = frame.src;
    },
    onUpdate: (self) => {
        const frameIndex = Math.min(
            Math.floor(self.progress * DUMPSTEREARTH_TOTAL_FRAMES),
            DUMPSTEREARTH_TOTAL_FRAMES - 1
        );
        const frame = nearestFrame(dumpsterearthFrames, frameIndex);
        if (frame) dumpsterearthImg.src = frame.src;
    },
});

// --- Geology cross-section image sequence (5 PNGs, lazy-loaded) ---
const GEOLOGY_TOTAL_FRAMES = 5;
const GEOLOGY_BASE_URL =
    screenSize === "desktop"
        ? "https://static.propublica.org/projects/graphics/2026-ccs-explainer/crosssection-steps/20260608-problems-desktop-step-"
        : "https://static.propublica.org/projects/graphics/2026-ccs-explainer/crosssection-steps/20260608-problems-mobile-step-";
const geologyUrls = makeUrls(GEOLOGY_BASE_URL, GEOLOGY_TOTAL_FRAMES, 1, 2, "webp");
const geologyFrames = new Array(GEOLOGY_TOTAL_FRAMES).fill(null);
const geologyImg = document.querySelector("#geology-sequence");
const geologyFirst = new Image();
geologyFirst.src = geologyUrls[0];
geologyFrames[0] = geologyFirst;
geologyImg.src = geologyUrls[0];
observeForLoad("#geology-step1", () => loadInBatches(geologyUrls, geologyFrames, 1, 10, 0));

function showGeologyFrame(index) {
    const frame = nearestFrame(geologyFrames, index);
    if (frame) geologyImg.src = frame.src;
}

const geologyLabelClog = document.querySelector("#geology-label-clog");
const geologyLabelBulge1 = document.querySelector("#geology-label-bulge-1");
const geologyLabelBulge2 = document.querySelector("#geology-label-bulge-2");

const setOpacity = (labels, val) => [labels].flat().forEach(el => { if (el) el.style.opacity = val; });

[
    { step: "#geology-step1", enter: 1, leaveBack: 0 },
    { step: "#geology-step2", enter: 2, leaveBack: 1, showLabel: geologyLabelClog },
    { step: "#geology-step3", enter: 3, leaveBack: 2, showLabel: [geologyLabelBulge1, geologyLabelBulge2], hideLabel: geologyLabelClog },
    { step: "#geology-step4", enter: 4, leaveBack: 3, hideLabel: [geologyLabelBulge1, geologyLabelBulge2] },
    { step: "#geology-step5" },
].forEach(({ step, enter, leaveBack, showLabel, hideLabel }) => {
    ScrollTrigger.create({
        trigger: step,
        start: screenSize === "mobile" ? "top 70%" : "top 75%",
        onEnter: () => {
            if (enter !== undefined) showGeologyFrame(enter);
            if (showLabel) setOpacity(showLabel, 1);
            if (hideLabel) setOpacity(hideLabel, 0);
        },
        onLeaveBack: () => {
            if (leaveBack !== undefined) showGeologyFrame(leaveBack);
            if (showLabel) setOpacity(showLabel, 0);
            if (hideLabel) setOpacity(hideLabel, 1);
        }
        // markers:true,
    });
});



// PIPELINE //
[
    { targets: "#pipeline-step1",                        trigger: "#pipeline-step1" },
    { targets: ["#pipeline-step2", "#pipeline-plane"],   trigger: "#pipeline-step2" },
    { targets: ["#pipeline-step3", "#pipeline-signs"],   trigger: "#pipeline-step3" },
    { targets: "#pipeline-step4",                        trigger: "#pipeline-step4" },
].forEach(({ targets, trigger }) => {
    gsap.to(targets, {
        opacity: 1,
        ease: "power1.inOut",
        scrollTrigger: {
            trigger,
            start: "top 80%",
            end: "+=200",
            scrub:true,
            //markers:true,
            //toggleActions: "play none none reverse",
        }
    });
});

// SHIP GRID //

const SHIP_ROWS_DESKTOP = [14, 13, 12, 11, 9, 7, 6, 6, 5, 2, 1];
const SHIP_ROWS_MOBILE = [10, 10, 9, 8, 7, 6, 6, 5, 4, 3, 2, 1];
const SHIP_ROWS_CONTROLLED_DESKTOP = 9;
const SHIP_ROWS_CONTROLLED_MOBILE = 10;

// top X% at which each controlled row (0=topmost) reaches full opacity
const SHIP_ROW_TARGETS_DESKTOP = [10,15, 20, 25, 30, 35, 40, 45, 50, 55, 60];
const SHIP_ROW_TARGETS_MOBILE = [10, 20, 25, 30, 35, 40, 45, 50, 55, 60];

const shipGrid = document.querySelector('#ship-grid');

const SHIP_ROWS = screenSize === 'mobile' ? SHIP_ROWS_MOBILE : SHIP_ROWS_DESKTOP;
const SHIP_ROWS_CONTROLLED = screenSize === 'mobile' ? SHIP_ROWS_CONTROLLED_MOBILE : SHIP_ROWS_CONTROLLED_DESKTOP;
const SHIP_ROW_TARGETS = screenSize === 'mobile' ? SHIP_ROW_TARGETS_MOBILE : SHIP_ROW_TARGETS_DESKTOP;

if (shipGrid) {
    observeForLoad('#ships-step1', () => {
        const shipRowEls = [];

        SHIP_ROWS.forEach((cellCount, i) => {
            const row = document.createElement('div');
            row.className = 'ship-row';
            const isLastRow = i === SHIP_ROWS.length - 1;
            row.style.flexGrow = Math.pow(screenSize === 'mobile' ? 1.25 : 1.4, i);
            if (i < SHIP_ROWS_CONTROLLED) row.style.opacity = 0;
            for (let j = 0; j < cellCount; j++) {
                const cell = document.createElement('div');
                cell.className = 'ship-cell';
                const img = document.createElement('img');
                img.src = 'https://static.propublica.org/projects/graphics/2026-ccs-explainer/boats/20260610-boat-water.webp';
                img.alt = '';
                const vOffset = (Math.random() - 0.5) * 20;
                const hOffset = (Math.random() - 0.5) * 20;
                img.style.top = isLastRow ? '10%' : `${50 + vOffset}%`;
                img.style.left = isLastRow ? '50%' :`${50 + hOffset}%`;
                cell.appendChild(img);
                row.appendChild(cell);
            }
            shipGrid.appendChild(row);
            shipRowEls.push(row);
        });

        // Each controlled row fades from its rowStartProgress to rowEndProgress.
        // rowStartProgress[i] = the scroll progress at which the row below it (i+1) hits 0.7 opacity,
        // so each row is nearly visible before the row above it begins fading in.
        const shipRowEndProgress = Array.from({ length: SHIP_ROWS_CONTROLLED }, (_, i) =>
            (100 - SHIP_ROW_TARGETS[i]) / 90
        );
        const shipRowStartProgress = new Array(SHIP_ROWS_CONTROLLED).fill(0);
        for (let i = SHIP_ROWS_CONTROLLED - 2; i >= 0; i--) {
            const prevStart = shipRowStartProgress[i + 1];
            const prevEnd = shipRowEndProgress[i + 1];
            shipRowStartProgress[i] = prevStart + 0.7 * (prevEnd - prevStart);
        }

        ScrollTrigger.create({
            trigger: '#ships-step1',
            start: 'top bottom',
            end: 'top 20%',
           // markers:true,
            onUpdate: (self) => {
                for (let i = 0; i < SHIP_ROWS_CONTROLLED; i++) {
                    const duration = shipRowEndProgress[i] - shipRowStartProgress[i];
                    const raw = (self.progress - shipRowStartProgress[i]) / duration;
                    shipRowEls[i].style.opacity = Math.max(0, Math.min(1, raw));
                }
            },
        });
    }, "200% 0px");
}

// solar projections line chart
async function buildSolarChart() {
    const container = document.querySelector('#solar-chart');
    if (!container) return;

    const [data, actualLineData] = await Promise.all([
        d3.csv(
            'https://static.propublica.org/projects/graphics/2026-ccs-explainer/01_data/20260603_solar_projections_filtered.csv',
            d => ({
                source: d.source,
                whichPrediction: +d.which_prediction,
                year: +d.year,
                value: +d.world_solar_pv_twh,
            })
        ),
        d3.csv(
            'https://static.propublica.org/projects/graphics/2026-ccs-explainer/01_data/20260514_solar_actual.csv',
            d => ({
                year: +d.year,
                value: +d.world_solar_pv_twh,
            })
        ),
    ]);

    const projRows = data;
    const seriesMap = d3.group(projRows, d => `${d.source}|${d.whichPrediction}`);
    const yMax = d3.max(projRows, d => d.value);

    const margin = { top: 20, right: 20, bottom: 40, left: 20 };
    const clipId = 'solar-chart-clip';

    const svg = d3.select(container).append('svg');
    const defs = svg.append('defs');
    defs.append('clipPath').attr('id', clipId).append('rect');
    const g = svg.append('g').attr('transform', `translate(${margin.left},${margin.top})`);
    const gridGroup = g.append('g');
    const linesGroup = g.append('g').attr('clip-path', `url(#${clipId})`);
    const xAxisG = g.append('g');
    const yAxisG = g.append('g');

    function render() {
        const width = container.clientWidth - margin.left - margin.right;
        const height = container.clientHeight - margin.top - margin.bottom;

        svg.attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom);

        defs.select('clipPath rect').attr('width', width).attr('height', height);

        const x = d3.scaleLinear().domain([2010, 2040]).range([0, width]);
        const y = d3.scaleLinear().domain([0, 2100]).range([height, 0]).nice();

        const lineGen = d3.line()
            .x(d => x(d.year))
            .y(d => y(d.value))
            .defined(d => !isNaN(d.value));

        linesGroup.selectAll('path.proj').data([...seriesMap.values()])
            .join('path')
            .attr('class', 'proj')
            .attr('fill', 'none')
            .attr('stroke', projectionColor)
            .attr('stroke-width', 2)
            .attr('opacity', 1)
            .attr('d', points => lineGen([...points].sort((a, b) => a.year - b.year)));

        if (actualLineData.length > 0) {
            linesGroup.selectAll('path.actual-line').data([actualLineData])
                .join('path')
                .attr('class', 'actual-line')
                .attr('fill', 'none')
                .attr('stroke', actualColor)
                .attr('stroke-width', 4)
                .attr('d', rows => lineGen([...rows].sort((a, b) => a.year - b.year)));
        }

        const yTickValues = [1000, 2000];

        gridGroup.selectAll('line').data(yTickValues)
            .join('line')
            .attr('x1', 0)
            .attr('x2', width)
            .attr('y1', d => y(d))
            .attr('y2', d => y(d))
            .style('stroke', axisColor)
            .style('opacity', axisOpacity)
            .style('stroke-width', '1px');

        xAxisG.attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x).tickFormat(d3.format('d')).ticks(8));

        yAxisG.call(
            d3.axisLeft(y)
                .tickValues(yTickValues)
                .tickSize(0)
                .tickFormat(d => d === 2000
                    ? `${d3.format(',')(d)} terawatt-hour`
                    : d3.format(',')(d))
        );

        xAxisG.selectAll('text')
            .style('font-family', 'var(--p-fonts-sans)')
            .style('font-size', 'var(--p-scale-2)')
            .style('fill', axisColor)
            .style('opacity', axisTextOpacity)
            .attr('dy', '1.4em');

        yAxisG.selectAll('text')
            .style('font-family', 'var(--p-fonts-sans)')
            .style('font-size', 'var(--p-scale-2)')
            .style('fill', axisColor)
            .style('opacity', axisTextOpacity)
            .attr('x', 5)
            .attr('dy', '-0.4em')
            .attr('text-anchor', 'start');

        xAxisG.selectAll('.domain, .tick line')
            .style('stroke', axisColor)
            .style('opacity', axisOpacity);

        yAxisG.selectAll('.domain').style('display', 'none');
    }

    render();
    requestAnimationFrame(render);
    new ResizeObserver(render).observe(container);
}

buildSolarChart();

// modeled after https://github.com/bizweekgraphics/swoopyarrows
function swoopyArrow() {
    let angle = Math.PI * 0.4;
    let clockwise = false;

    function render(x0, y0, x1, y1) {
        const h = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2));
        const d = h / (2 * Math.tan(angle / 2));
        const r = Math.sqrt(d * d + (h / 2) * (h / 2));
        return `M ${x0},${y0} a ${r},${r} 0 0,${clockwise ? 1 : 0} ${x1 - x0},${y1 - y0}`;
    }

    render.angle = function(_) {
        if (!arguments.length) return angle;
        angle = Math.min(Math.max(_, 1e-6), Math.PI - 1e-6);
        return render;
    };

    render.clockwise = function(_) {
        if (!arguments.length) return clockwise;
        clockwise = !!_;
        return render;
    };

    return render;
}

function addChartArrowMarker(defs, markerId) {
    defs.append('marker')
        .attr('id', markerId)
        .attr('viewBox', '-10 -10 20 20')
        .attr('refX', 0)
        .attr('refY', 0)
        .attr('markerWidth', 20)
        .attr('markerHeight', 20)
        .attr('stroke-width', 2)
        .attr('orient', 'auto')
        .attr('markerUnits', 'userSpaceOnUse')
        .append('polyline')
        .attr('points', '-6.75,-6.75 0,0 -6.75,6.75')
        .attr('stroke-linejoin', 'bevel')
        .attr('stroke', actualColor)
        .attr('fill', 'none');
}

function renderActualConnector(connectorGroup, svg, margin, labelEl, actualLineData, x, y, opacity, markerId) {
    if (!labelEl || !actualLineData.length) return;
    const firstPoint = [...actualLineData].sort((a, b) => a.year - b.year)[0];
    const svgRect = svg.node().getBoundingClientRect();
    const labelRect = labelEl.getBoundingClientRect();
    const pad = 6;
    const sx = (labelRect.left - svgRect.left - margin.left) - pad;
    const sy = (labelRect.top + labelRect.height / 2) - svgRect.top - margin.top;
    const ex = x(firstPoint.year) + 60;
    const ey = y(firstPoint.value) - pad;
    const arcPath = swoopyArrow().angle(Math.PI * 0.4).clockwise(false)(sx, sy, ex, ey);
    connectorGroup.selectAll('path.actual-connector').data([1])
        .join('path')
        .attr('class', 'actual-connector')
        .attr('d', arcPath)
        .attr('fill', 'none')
        .attr('stroke', actualColor)
        .attr('stroke-width', 2)
        .attr('marker-end', `url(#${markerId})`)
        .style('opacity', opacity);
}

// ccs projections line chart
function buildCcsChart(data, actualLineData) {
    const container = document.querySelector('#ccs-chart');
    if (!container) return;

    const data2008 = data.filter(d => d.predictionYear === 2008);
    const data2008Step1 = data2008.filter(d => d.year >= 2010 && d.year <= 2025);
    const data2008Step2 = data2008.filter(d => d.year >= 2025);
    const seriesMap = d3.group(data.filter(d => d.predictionYear !== 2008), d => `${d.source}|${d.whichPrediction}`);
    const point2025 = data2008Step1.find(d => d.year === 2025);
    const line2008Ref = { path: null, length: 0, dot: null, progress: 0, dotOpacity: 0 };
    const actualRef = { path: null, length: 0, progress: 0 };
    let projOpacity = 0;
    let proj2008Step2Opacity = 0;

    const margin = { top: 20, right: 20, bottom: 40, left: 20 };
    const clipId = 'ccs-chart-clip';

    const ccsActualLabelEl = document.querySelector('#ccs-chart-label__actual');
    if (ccsActualLabelEl) ccsActualLabelEl.style.opacity = 0;

    const svg = d3.select(container).append('svg');
    const defs = svg.append('defs');
    defs.append('clipPath').attr('id', clipId).append('rect');
    const g = svg.append('g').attr('transform', `translate(${margin.left},${margin.top})`);
    const gridGroup = g.append('g');
    const linesGroup = g.append('g').attr('clip-path', `url(#${clipId})`);
    const arrowMarkerId = 'ccs-actual-arrow';
    addChartArrowMarker(defs, arrowMarkerId);
    const connectorGroup = g.append('g');
    const xAxisG = g.append('g');
    const yAxisG = g.append('g');

    function render() {
        const width = container.clientWidth - margin.left - margin.right;
        const height = container.clientHeight - margin.top - margin.bottom;

        svg.attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom);

        defs.select('clipPath rect').attr('width', width).attr('height', height);

        const x = d3.scaleLinear().domain([2010, 2040]).range([0, width]);
        const y = d3.scaleLinear().domain([0, 5500]).range([height, 0]);

        const lineGen = d3.line()
            .x(d => x(d.year))
            .y(d => y(d.value))
            .defined(d => !isNaN(d.value));

        linesGroup.selectAll('path.proj').data([...seriesMap.values()])
            .join('path')
            .attr('class', 'proj')
            .attr('fill', 'none')
            .attr('stroke', projectionColor)
            .attr('stroke-width', 2)
            .attr('d', points => lineGen([...points].sort((a, b) => a.year - b.year)));

        linesGroup.selectAll('path.proj').style('opacity', projOpacity);

        linesGroup.selectAll('path.proj-2008').data([data2008Step1])
            .join('path')
            .attr('class', 'proj-2008')
            .attr('fill', 'none')
            .attr('stroke', projectionColor)
            .attr('stroke-width', 2)
            .attr('opacity', 1)
            .attr('d', points => lineGen([...points].sort((a, b) => a.year - b.year)));

        const path2008 = linesGroup.select('path.proj-2008').node();
        if (path2008) {
            const len = path2008.getTotalLength();
            path2008.style.strokeDasharray = len;
            if (!line2008Ref.path) path2008.style.strokeDashoffset = len;
            line2008Ref.path = path2008;
            line2008Ref.length = len;
        }

        linesGroup.selectAll('path.proj-2008-step2').data([data2008Step2])
            .join('path')
            .attr('class', 'proj-2008-step2')
            .attr('fill', 'none')
            .attr('stroke', projectionColor)
            .attr('stroke-width', 2)
            .attr('d', points => lineGen([...points].sort((a, b) => a.year - b.year)));

        linesGroup.select('path.proj-2008-step2').style('opacity', proj2008Step2Opacity);

        if (point2025) {
            linesGroup.selectAll('circle.dot-2008-2025').data([point2025])
                .join('circle')
                .attr('class', 'dot-2008-2025')
                .attr('cx', d => x(d.year))
                .attr('cy', d => y(d.value))
                .attr('r', 5)
                .attr('fill', projectionColor);

            const dot = linesGroup.select('circle.dot-2008-2025').node();
            line2008Ref.dot = dot;
            dot.style.opacity = line2008Ref.dotOpacity;
        }

        if (actualLineData.length > 0) {
            linesGroup.selectAll('path.actual-line').data([actualLineData])
                .join('path')
                .attr('class', 'actual-line')
                .attr('fill', 'none')
                .attr('stroke', actualColor)
                .attr('stroke-width', 6)
                .attr('d', rows => lineGen([...rows].sort((a, b) => a.year - b.year)));

            const pathActual = linesGroup.select('path.actual-line').node();
            if (pathActual) {
                actualRef.path = pathActual;
                pathActual.style.opacity = actualRef.progress;
            }

            renderActualConnector(connectorGroup, svg, margin, ccsActualLabelEl, actualLineData, x, y, actualRef.progress, arrowMarkerId);
        }

        const yTickValues = [2000, 4000];

        gridGroup.selectAll('line').data(yTickValues)
            .join('line')
            .attr('x1', 0)
            .attr('x2', width)
            .attr('y1', d => y(d))
            .attr('y2', d => y(d))
            .style('stroke', axisColor)
            .style('opacity', axisOpacity)
            .style('stroke-width', '1px');

        xAxisG.attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x).tickFormat(d3.format('d')).ticks(8));

        yAxisG.call(
            d3.axisLeft(y)
                .tickValues(yTickValues)
                .tickSize(0)
                .tickFormat(d => d === 4000
                    ? `${d3.format(',')(d)} megatons`
                    : d3.format(',')(d))
        );

        xAxisG.selectAll('text')
            .style('font-family', 'var(--p-fonts-sans)')
            .style('font-size', 'var(--p-scale-2)')
            .style('fill', axisColor)
            .style('opacity', axisTextOpacity)
            .attr('dy', '1.4em');

        yAxisG.selectAll('text')
            .style('font-family', 'var(--p-fonts-sans)')
            .style('font-size', 'var(--p-scale-2)')
            .style('fill', axisColor)
            .style('opacity', axisTextOpacity)
            .attr('x', 5)
            .attr('dy', '-0.4em')
            .attr('text-anchor', 'start');

        xAxisG.selectAll('.domain, .tick line')
            .style('stroke', axisColor)
            .style('opacity', axisOpacity);

        yAxisG.selectAll('.domain').style('display', 'none');
    }

    render();
    window.addEventListener('resize', throttle(render, 200));

    ScrollTrigger.create({
        trigger: '#ccs-chart-step1',
        start: 'top bottom',
        end: 'top 25%',
        onUpdate: (self) => {
            line2008Ref.progress = self.progress;
            if (line2008Ref.path) {
                line2008Ref.path.style.strokeDashoffset =
                    line2008Ref.length * (1 - self.progress);
            }
            if (line2008Ref.dot) {
                line2008Ref.dotOpacity = self.progress >= 1 ? 1 : 0;
                line2008Ref.dot.style.opacity = line2008Ref.dotOpacity;
            }
        },
    });

    ScrollTrigger.create({
        trigger: '#ccs-chart-step3',
        start: 'top bottom',
        end: 'top center',
        // markers: 'true',
        onUpdate: (self) => {
            actualRef.progress = self.progress;
            if (actualRef.path) {
                actualRef.path.style.opacity = self.progress;
            }
            if (ccsActualLabelEl) ccsActualLabelEl.style.opacity = self.progress;
            connectorGroup.select('path.actual-connector').style('opacity', self.progress);
        },
    });

    const ccsProjLabelEl = document.querySelector('#ccs-chart-label__projections');
    if (ccsProjLabelEl) ccsProjLabelEl.style.opacity = 0;

    ScrollTrigger.create({
        trigger: '#ccs-chart-step2',
        start: 'top bottom',
        end: 'top center',
        onUpdate: (self) => {
            projOpacity = self.progress * 1;
            linesGroup.selectAll('path.proj').style('opacity', projOpacity);
            proj2008Step2Opacity = self.progress * 1;
            linesGroup.select('path.proj-2008-step2').style('opacity', proj2008Step2Opacity);
            if (line2008Ref.dot) {
                line2008Ref.dotOpacity = 1 - self.progress;
                line2008Ref.dot.style.opacity = line2008Ref.dotOpacity;
            }
            if (ccsProjLabelEl) ccsProjLabelEl.style.opacity = self.progress;
        },
    });
}

// ccs projections line chart (static, no animation)
function buildCcsChart2(data, actualLineData) {
    const container = document.querySelector('#ccs-chart-2');
    if (!container) return;

    const seriesMap = d3.group(data, d => `${d.source}|${d.whichPrediction}`);

    const margin = { top: 20, right: 20, bottom: 40, left: 20 };
    const clipId = 'ccs-chart-2-clip';

    const svg = d3.select(container).append('svg');
    const defs = svg.append('defs');
    defs.append('clipPath').attr('id', clipId).append('rect');
    const g = svg.append('g').attr('transform', `translate(${margin.left},${margin.top})`);
    const gridGroup = g.append('g');
    const linesGroup = g.append('g').attr('clip-path', `url(#${clipId})`);
    const xAxisG = g.append('g');
    const yAxisG = g.append('g');

    function render() {
        const width = container.clientWidth - margin.left - margin.right;
        const height = container.clientHeight - margin.top - margin.bottom;

        svg.attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom);

        defs.select('clipPath rect').attr('width', width).attr('height', height);

        const x = d3.scaleLinear().domain([2010, 2040]).range([0, width]);
        const y = d3.scaleLinear().domain([0, 5500]).range([height, 0]);

        const lineGen = d3.line()
            .x(d => x(d.year))
            .y(d => y(d.value))
            .defined(d => !isNaN(d.value));

        linesGroup.selectAll('path.proj').data([...seriesMap.values()])
            .join('path')
            .attr('class', 'proj')
            .attr('fill', 'none')
            .attr('stroke', projectionColor)
            .attr('stroke-width', 2)
            .attr('opacity', 1)
            .attr('d', points => lineGen([...points].sort((a, b) => a.year - b.year)));

        if (actualLineData.length > 0) {
            linesGroup.selectAll('path.actual-line').data([actualLineData])
                .join('path')
                .attr('class', 'actual-line')
                .attr('fill', 'none')
                .attr('stroke', actualColor)
                .attr('stroke-width', 6)
                .attr('d', rows => lineGen([...rows].sort((a, b) => a.year - b.year)));

        }

        const yTickValues = [2000, 4000];

        gridGroup.selectAll('line').data(yTickValues)
            .join('line')
            .attr('x1', 0)
            .attr('x2', width)
            .attr('y1', d => y(d))
            .attr('y2', d => y(d))
            .style('stroke', axisColor)
            .style('opacity', axisOpacity)
            .style('stroke-width', '1px');

        xAxisG.attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x).tickFormat(d3.format('d')).ticks(8));

        yAxisG.call(
            d3.axisLeft(y)
                .tickValues(yTickValues)
                .tickSize(0)
                .tickFormat(d => d === 4000
                    ? `${d3.format(',')(d)} megatons`
                    : d3.format(',')(d))
        );

        xAxisG.selectAll('text')
            .style('font-family', 'var(--p-fonts-sans)')
            .style('font-size', 'var(--p-scale-2)')
            .style('fill', axisColor)
            .style('opacity', axisTextOpacity)
            .attr('dy', '1.4em');

        yAxisG.selectAll('text')
            .style('font-family', 'var(--p-fonts-sans)')
            .style('font-size', 'var(--p-scale-2)')
            .style('fill', axisColor)
            .style('opacity', axisTextOpacity)
            .attr('x', 5)
            .attr('dy', '-0.4em')
            .attr('text-anchor', 'start');

        xAxisG.selectAll('.domain, .tick line')
            .style('stroke', axisColor)
            .style('opacity', axisOpacity);

        yAxisG.selectAll('.domain').style('display', 'none');
    }

    render();
    requestAnimationFrame(render);
    new ResizeObserver(render).observe(container);
}

(async () => {
    const [data, actualLineData] = await Promise.all([
        d3.csv(
            'https://static.propublica.org/projects/graphics/2026-ccs-explainer/01_data/20260603_ccs_projections_filtered.csv',
            d => ({
                source: d.source,
                whichPrediction: +d.which_prediction,
                predictionYear: +d.prediction_year,
                year: +d.year,
                value: +d.mt_co2_per_yr,
            })
        ),
        d3.csv(
            'https://static.propublica.org/projects/graphics/2026-ccs-explainer/01_data/20260521_ccs_actual.csv',
            d => +d.year >= 2010 ? ({
                year: +d.year,
                value: +d.mt_co2_per_yr,
            }) : null
        ),
    ]);
    buildCcsChart(data, actualLineData);
    buildCcsChart2(data, actualLineData);

    ScrollTrigger.create({
        trigger: '#solar-chart-step2',
        start: 'top 70%',
        onEnter: () => {
            gsap.to('#solar-chart path.proj, #ccs-chart-2 path.proj, #ccs-chart-2 path.proj-2008', {
                opacity: 0,
                duration: 0.5,
            });
            gsap.to('#ccs-chart-2-label__projections, #solar-chart-label__projections', {
                opacity: 0,
                duration: 0.5,
            });
        },
        onLeaveBack: () => {
            gsap.to('#solar-chart path.proj, #ccs-chart-2 path.proj, #ccs-chart-2 path.proj-2008', {
                opacity: 1,
                duration: 0.5,
            });
            gsap.to('#ccs-chart-2-label__projections, #solar-chart-label__projections', {
                opacity: 1,
                duration: 0.5,
            });
        },
        // markers: true,
    });
})();

